import {
  Button,
  Card,
  Division,
  Flex,
  Heading,
  Icon,
  Icons,
  Paragraph,
  Spin,
} from "@ir/ui";
import type { ReactNode } from "react";
import { Permissions } from "@src/domain/permissions";
import HasAnyPermission from "@src/presentation/components/permissions/HasAnyPermission";
import { ConfigSearchInput } from "./ConfigSearchInput";

interface ConfigWritableListLayoutProps {
  title: string;
  subtitle: string;
  searchPlaceholder: string;
  search: string;
  setSearch: (search: string) => void;
  addButtonLabel: string;
  onAdd: () => void;
  loading: boolean;
  children: ReactNode;
}

export const ConfigWritableListLayout = ({
  title,
  subtitle,
  searchPlaceholder,
  search,
  setSearch,
  addButtonLabel,
  onAdd,
  loading,
  children,
}: ConfigWritableListLayoutProps) => {
  return (
    <Card
      className="config-list-page bg-white"
      variant="outlined"
      shadow
      padding="small"
    >
      <Flex
        align="center"
        justifyContent="space-between"
        gap={0.75}
        className="config-list-page__header mb-3"
      >
        <Flex direction="column" gap={0.15}>
          <Heading level={6} className="text-grey-700 font-bold m-0">
            {title}
          </Heading>
          <Paragraph className="text-grey-500 m-0">{subtitle}</Paragraph>
        </Flex>
        <Flex align="center" gap={0.5}>
          <ConfigSearchInput
            placeholder={searchPlaceholder}
            searchQuery={search}
            onSearch={setSearch}
            onClear={() => setSearch("")}
            minLength={1}
            fields={["Purchaser Name", "Purchaser Key", "Portal Key"]}
          />
          <HasAnyPermission requiredPermissions={[Permissions.CONFIG_ADD]}>
            <Button size="small" color="primary" onPress={onAdd}>
              <Icon slot="start" name={Icons.Plus} />
              {addButtonLabel}
            </Button>
          </HasAnyPermission>
        </Flex>
      </Flex>
      <Division className="config-list-page__body">
        {loading ? (
          <Flex align="center" justifyContent="center" className="py-6">
            <Spin tip="Loading..." spinning />
          </Flex>
        ) : (
          children
        )}
      </Division>
    </Card>
  );
};
